<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-4 w-100">
      <h4 class="title"><i class="fas fa-shield-alt"></i> {{entityName | translate}}</h4>
    </div>
    <div class="col-md-2 mt-4 content-position-end">
      <button type="button"
              class="btn btn-outline-success  mw-180 font-weight-bold custom-button"
              *ngIf="hasAuthority('own:authority:add')"
              (click)="openAddModal()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div>
  <div class="row mt-2">
    <div class="col-md-2 custom-mr-17 custom-col-md-2">
      <label class="font-weight-bold">{{ "LABEL.MODULE" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-cube"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="moduleSelected"
                (ngModelChange)="reloadAuthorities()">
          <option *ngFor="let module of modules" [ngValue]="module">{{module.description | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3 custom-mr-17">
      <label class="font-weight-bold">{{ "LABEL.CODE-DESCRIPTION" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
        </div>
        <input type="text"
               id="searchInput"
               class="form-control"
               placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
               [(ngModel)]="term2Search"
               (keyup.enter)="search()">
      </div>
    </div>
    <div class="col-md-2 custom-mt-24">
      <button type="button"
              class="btn btn-outline-success custom-button"
              [disabled]="term2Search === undefined"
              (click)="search()"><i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
      </button>
    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col" title="#"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.MODULE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.CODE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let authority of authorities; let index=index">
        <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
        <td title="{{ 'TABLE.HEADER.MODULE' | translate }}">{{getModuleDescription(authority.module)}}</td>
        <td title="{{ 'TABLE.HEADER.CODE' | translate }}">{{authority.code}}</td>
        <td title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}">{{authority.description}}</td>
        <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{authority.createAt | dateformat}}</td>
        <td title="{{ 'TABLE.HEADER.STATE' | translate }}"><span
          class="{{!authority.active? 'badge badge-danger':''}}">{{authority.active ? 'Activo' : 'Inactivo'}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <button type="button" class="btn btn-default " id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:authority:edit')"
                      (click)="openEditModal(authority)">
                <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
              </button>
              <button class="dropdown-item pointer"
                      *ngIf="hasAuthority('own:authority:delete')"
                      (click)="openModalDelete(authority)">
                <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="reloadAuthorities()">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{authorities.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadAuthorities(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadAuthorities(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadAuthorities(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadAuthorities(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
